import React from 'react'
import VehicleDetailContainer from './VehicleDetailContainer'

const VehicleDetail = () => <VehicleDetailContainer data-test="component-stock-vehicle-detail" />
export default VehicleDetail
